/* eslint-disable max-len */
import {RadioButton} from 'primereact/radiobutton';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import equal from 'react-fast-compare';
import {withTranslation} from 'react-i18next';
import {FilterMatchMode} from 'primereact/api';

class CriteriaRadioButtonComponent extends Component {
    render() {
        const {
            colClass,
            disabled,
            id,
            insideTable,
            itemColClass,
            label,
            labelOnRight,
            name,
            onAfterStateChange,
            onChange,
            options,
            showLabel,
            validator,
            validators,
            value,
            valueKey,
            valueLabel,
            showDescription,
            description,
            descriptionClassName,
            refreshFromBackend,
        } = this.props;
        const required = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
        return (
            <div className={insideTable ? '' : colClass} id={id}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {label !== undefined && showLabel ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {label}
                            </label>
                        ) : null}
                        <div aria-label={label} aria-labelledby={`${id}-label-id`} className='row'>
                            {options && options.length > 0
                                ? options.map((val) => {
                                      return (
                                          <div
                                              className={itemColClass}
                                              key={`div-${valueKey ? val[valueKey] : valueLabel ? val[valueLabel] : val}`}
                                          >
                                              <RadioButton
                                                  aria-describedby={`${id}-error`}
                                                  aria-label={`${label} ${valueLabel ? val[valueLabel] : val}`}
                                                  key={`${id}-${valueKey ? val[valueKey] : valueLabel ? val[valueLabel] : val}`}
                                                  id={`${id}-${valueKey ? val[valueKey] : valueLabel ? val[valueLabel] : val}`}
                                                  inputId={`${id}-input-${valueKey ? val[valueKey] : valueLabel ? val[valueLabel] : val}`}
                                                  name={name}
                                                  onChange={(e) =>
                                                      onChange
                                                          ? onChange('RADIOBUTTON', valueKey, e, FilterMatchMode.EQUALS, refreshFromBackend, onAfterStateChange)
                                                          : null
                                                  }
                                                //   onChange={(e) =>
                                                //     onChange ? onChange('NUMBER', undefined, e, FilterMatchMode.EQUALS, refreshFromBackend, onAfterStateChange) : null
                                                // }
                                                  value={val}
                                                  checked={value ? (valueKey ? value === val[valueKey] : equal(value, val)) : false}
                                                  disabled={disabled}
                                                  required={required}
                                              />
                                              {labelOnRight ? (
                                                  <label
                                                      key={`label-${valueKey ? val[valueKey] : valueLabel ? val[valueLabel] : val}`}
                                                      htmlFor={`${id}-input-${
                                                          valueKey ? val[valueKey] : valueLabel ? val[valueLabel] : val
                                                      }`}
                                                      className='p-checkbox-label p-label'
                                                  >
                                                      {valueLabel ? val[valueLabel] : val}
                                                  </label>
                                              ) : null}
                                              {showDescription && description && description !== '' ? (
                                                  <label
                                                      key={`label-${description ? val[description] : description ? val[description] : val}`}
                                                      htmlFor={`${id}-input-${
                                                          description ? val[description] : description ? val[description] : val
                                                      }`}
                                                      className={descriptionClassName}
                                                  >
                                                      {description ? val[description] : val}
                                                  </label>
                                              ) : null}
                                          </div>
                                      );
                                  })
                                : null}
                        </div>
                        <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                    </div>
                </div>
            </div>
        );
    }
}

CriteriaRadioButtonComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    insideTable: false,
    itemColClass: 'col-xl-12 col-lg-12 col-md-12 col-sm-12',
    labelOnRight: false,
    publicMode: false,
    rendered: true,
    showLabel: true,
    validateViewMode: false,
    validators: 'array_required',
    showDescription: false,
    descriptionClassName: 'p-checkbox-label p-label',
    refreshFromBackend: false,
};

CriteriaRadioButtonComponent.propTypes = {
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    itemColClass: PropTypes.string,
    label: PropTypes.string,
    labelOnRight: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    publicMode: PropTypes.bool,
    rendered: PropTypes.bool,
    renderValue: PropTypes.func,
    showLabel: PropTypes.bool,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object,
    validators: PropTypes.string,
    value: PropTypes.any,
    valueKey: PropTypes.string.isRequired,
    valueLabel: PropTypes.string.isRequired,

    description: PropTypes.string,
    showDescription: PropTypes.bool,
    descriptionClassName: PropTypes.string,
    refreshFromBackend: PropTypes.bool,
};

export default withTranslation()(CriteriaRadioButtonComponent);
